
import {Component, Prop, Vue} from 'vue-property-decorator';
import vModal from '@/components/vModal.vue';
import {mapState} from "vuex";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import { round } from "@/utils/Helpers";
import { Recipe } from '@/models/Recipes/Recipe';
import { SingleNutrientReportDto } from '@/models/Recipes/SingleNutrientReportDto';
import CalculationsRepository from '@/utils/API/CalculationsRepository';
import vTable from '@/components/vTable.vue';
import vPreLoader from '@/components/vPreLoader.vue';
// Chartjs 2.x does not provide type declarations
// @ts-expect-error
import Chart from "chart.js";
import VGenericTable from "@/components/bootstrap/vGenericTable.vue";

@Component({
  components: {
    VGenericTable,
    vModal,
    vTable,
    vPreLoader,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vSingleNutrientReportModal extends Vue {
  localizationState: LocalizationState;
  singleNutrientProfile: SingleNutrientReportDto = {
    id: 0,
    name: '',
    ingredients: [],
  };

  @Prop() recipe: Recipe;
  @Prop() showSingleNutrientReportModal: boolean;

  get translations() {
    return this.localizationState.translations;
  }

  closeSingleNutrientModal() {
    this.$emit('on-cancel');
  }

  getSingleNutrientProfile() {
    CalculationsRepository.getSingleNutrientReport(this.recipe.id)
      .then((response) => {
        this.singleNutrientProfile = response.data.result;
        this.initCharts();
      })
      .catch((error) => {
        if (error.response) {
          this.$snotify.error(error.response.data.errorMessages[0].userVisibleMessage);
        }
        else this.$snotify.error(this.translations.get('network-error'));
      });
  }

  initCharts() {
    try {
      if (this.singleNutrientProfile.ingredients.length > 0) {
        const nutrientCanvas = document.getElementById('nutrientChart') as HTMLCanvasElement;
        const ctx = nutrientCanvas.getContext('2d');

        if (ctx) {
          const ingredientNames = this.singleNutrientProfile.ingredients.map((ingredient) => ingredient.name);
          const proteinPercentages = this.singleNutrientProfile.ingredients.map((ingredient) => round(ingredient.itemPercentageComposition, 2));

          const chart = new Chart(nutrientCanvas, {
            type: 'horizontalBar',
            data: {
              labels: ingredientNames,
              datasets: [
                {
                  label: 'Protein Percentage (%)',
                  data: proteinPercentages,
                  backgroundColor: 'rgba(183, 28, 2, 0.3)',
                  borderColor: 'rgba(183, 28, 2, 1)',
                  borderWidth: 1,
                },
              ],
            },
            options: {
              responsive: true,
              scales: {
                xAxes: [{
                  ticks: {
                    beginAtZero: true,
                    suggestedMax: 100
                  }
                }]
              }
            }
          });
        }
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  transformSingleNutrientReport() {
    if (this.singleNutrientProfile && this.singleNutrientProfile.ingredients.length > 0) {
      return this.singleNutrientProfile.ingredients.map((x) => {
        return {
          name: x.name,
          // weight: round(x.weightInGrams, 2),
          proteinGrams: round(x.itemInGrams, 2),
          proteinPercent: round(x.itemPercentageComposition, 2),
        };
      });
    }
    return [];
  }

  // Print functionality
  printModal() {
    const modalContent = document.querySelector('.modal-content-print');

    if (modalContent) {
      const printContainer = document.createElement('div');
      printContainer.innerHTML = modalContent.innerHTML;

      const style = document.createElement('style');
      printContainer.appendChild(style);

      document.body.appendChild(printContainer);
      window.print();

      document.body.removeChild(printContainer);
    }
  }
}
